<div class="ui-g">
  <div class="ui-g-12">
    <form [formGroup]="searchForm">
      <div class="filterPanel">
        <div class="ui-g">
          <div class="ui-g-2">
            <p-dropdown
              name="filterCommsEvent"
              [style]="{ width: '100%' }"
              (onChange)="fetchCommsHistory()"
              [options]="filterCommsEventChoices"
              formControlName="commsEventId"
            ></p-dropdown>
          </div>

          <div class="ui-g-2">
            <p-dropdown
              name="filterCustomerId"
              [style]="{ width: '100%' }"
              (onChange)="fetchCommsHistory()"
              [options]="filterCustomerChoices"
              formControlName="customerId"
            ></p-dropdown>
          </div>

          <div class="ui-g-2">
            <input
              pInputText="filterTemplateName"
              formControlName="templateName"
              placeholder="Template"
              style="width: 100%"
            />
          </div>

          <div class="ui-g-2">
            <p-dropdown
              name="filterCommsType"
              [style]="{ width: '100%' }"
              (onChange)="fetchCommsHistory()"
              [options]="filterCommsTypeChoices"
              formControlName="commsType"
            ></p-dropdown>
          </div>
          <div class="ui-g-1" style="white-space: nowrap">
            <input
              pInputText="filterUniqueId"
              formControlName="uniqueId"
              placeholder="Unique"
              style="width: 100%"
            />
          </div>
          <div class="ui-g-2" style="white-space: nowrap">
            <input
              pInputText="filterRecipient"
              formControlName="recipientAddress"
              placeholder="Recipient"
              style="width: 100%"
            />
          </div>
          <div class="ui-g-1">
            <button (click)="fetchCommsHistory()" pButton>
              <i class="fa fa-search" style="line-height: 30px"></i>
            </button>
          </div>
        </div>
      </div>
    </form>

    <p-table
      #dataTable
      [value]="commsHistories"
      selectionMode="single"
      [(selection)]="selectedItem"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 20]"
      [responsive]="true"
      [paginator]="true"
      [rowHover]="true"
      rowHover="true"
      resizableColumns="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Date Sent</th>
          <th>Event Code</th>
          <th>Title</th>
          <th>Template For</th>
          <th>Comms Type</th>
          <th>Model</th>
          <th pSortableColumn="uniqueId">Unique Id</th>
          <th pSortableColumn="recipientAddress">Recipient</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-itemUntyped>
        <ng-container *ngIf="asCommsHistorySearchItem(itemUntyped) as item">
          <tr [pSelectableRow]="item">
            <td>
              <div pTooltip="Date Sent">{{ item.dateSent | datex : 'DD/MM/YY HH:mm' }}</div>
            </td>
            <td>
              <div>{{ item.commsEventCode }}</div>
              <div class="event-title">
                {{ item.commsEventTitle }}
              </div>
            </td>
            <td>
              <div>{{ item.templateName }}</div>
            </td>
            <td>
              <div>
                {{ item.customerName }}
              </div>
            </td>
            <td>
              <div>{{ item.commsTypeName }}</div>
            </td>
            <td>
              <div *ngIf="item.mergeModelName">{{ item.mergeModelName }} - {{ item.modelId }}</div>
            </td>
            <td>
              <div>{{ item.uniqueId }}</div>
            </td>
            <td>
              <div>{{ item.recipientAddress }}</div>
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="card" *ngIf="selectedItem">
  <h2>Comms History Detail</h2>

  <table class="history-detail">
    <tr>
      <td class="col1">Date Sent</td>
      <td>{{ selectedItem?.dateSent }}</td>
    </tr>
    <tr>
      <td class="col1">Event Code</td>
      <td>{{ selectedItem?.commsEventCode }}</td>
    </tr>
    <tr>
      <td class="col1">Comms Type</td>
      <td>{{ selectedItem?.commsTypeName }}</td>
    </tr>
    <tr>
      <td class="col1">Customer Template</td>
      <td>
        {{ selectedItem?.customerName }}
      </td>
    </tr>
    <tr>
      <td class="col1">Recipient Address</td>
      <td>{{ selectedItem?.recipientAddress }}</td>
    </tr>
    <tr>
      <td class="col1">Model</td>
      <td>
        <div *ngIf="selectedItem?.mergeModelName">
          {{ selectedItem?.mergeModelName }} ({{ selectedItem.modelId }})
        </div>
      </td>
    </tr>
    <tr>
      <td class="col1">Response ID</td>
      <td>
        <div *ngIf="selectedItem?.externalLink">
          <a [href]="selectedItem.externalLink" target="_blank">{{ selectedItem?.responseId }}</a>
        </div>
        <div *ngIf="!selectedItem?.externalLink">
          {{ selectedItem?.responseId }}
        </div>
      </td>
    </tr>
    <tr>
      <td class="col1">Response Message</td>
      <td>{{ selectedItem?.responseMessage }}</td>
    </tr>
    <tr>
      <td class="col1">Response Status</td>
      <td>{{ selectedItem?.responseStatus }}</td>
    </tr>
    <tr>
      <td class="col1">BCC Address</td>
      <td>{{ selectedItem?.bccAddress }}</td>
    </tr>
    <tr>
      <td class="col1">Subject</td>
      <td>{{ selectedItem?.subject }}</td>
    </tr>
    <tr>
      <td class="col1">Body</td>
      <td>{{ selectedItem?.body }}</td>
    </tr>
  </table>
</div>
